import { getParsedNumber } from "../../utils/Common";
import { convertDateToLocale } from "./inventory.service";

const getBgColorClass = (record) => {
  const minStock = getParsedNumber(record.ingredient.minStock);
  const closingStock = getParsedNumber(record.closingStock);

  console.log('---getBgColorClass---', {minStock, closingStock});

  if (closingStock < 0) return 'bg-[#FF3044] text-white';
  if (closingStock < minStock) return 'bg-orange';
  
  return 'bg-white';
}

export function prepareInventoryReport(reports) {
  if (!Array.isArray(reports) || reports.length < 1) return [];
  return [
    ...reports.map((report) => ({
      id: crypto.randomUUID(),
      itemName: report.ingredient.name,
      openingStock: report.openingStock,
      addedQuantity: report.addedQuantity,
      wastage: report.wastageQuantity,
      usages: report.usagesQuantity,
      closingStock: report.closingStock,
      purchaseDate: convertDateToLocale(report.purchaseDate),
      unitPrice: report.unitPrice,
      totalPrice: report.totalPrice,
      extra: {bgColorClass: getBgColorClass(report)}
    })),
  ];
}

export function getReportsCurrentPageTotal(reports) {
  if (reports.length < 1) return;
  let total = 0;
  reports.map((item) => (total = total + Number(item.totalPrice)));
  return total;
}
